import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { AddSnippetModalComponent } from "./AddSnippetModalComponent";

const AddSnippetModal = ModalManager.create(() => <AddSnippetModalComponent />);

export const useAddSnippetModal = () => useModal(AddSnippetModal);
